import React from "react";
import { JsonViewToggle } from "../../../ui";
import { TraceInteractionView } from "./TraceInteractionView";

function hasStructuredTrace(trace: Record<string, any> | null | undefined): boolean {
  if (!trace) return false;
  const t = trace?.trace ?? trace;
  return !!(
    t?.agent_instance_by_id ||
    (Array.isArray(t?.agents) && t.agents.length > 0) ||
    (Array.isArray(t?.messages) && t.messages.length > 0) ||
    (t?.id != null && t?.name != null && Array.isArray(t?.interactions) && t.interactions.length > 0)
  );
}

interface TraceDisplayWithToggleProps {
  trace: Record<string, any> | null | undefined;
}

export function TraceDisplayWithToggle({ trace }: TraceDisplayWithToggleProps) {
  const hasStructured = hasStructuredTrace(trace);
  const traceData = trace ?? {};

  return (
    <JsonViewToggle
      data={traceData}
      hasStructured={hasStructured}
      formattedContent={<TraceInteractionView trace={traceData} />}
      title="Trace"
      emptyMessage="No structured trace to display."
      jsonViewMaxHeight="max-h-72"
    />
  );
}
